import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface DraftPrepHeaderProps {
  title: string;
  description: string;
  season: number;
  dynastyWeight: number;
  onSeasonChange: (season: number) => void;
  onDynastyWeightChange: (weight: number) => void;
  teams?: Array<{ teamId: string; teamName: string }>;
  currentTeamId?: string;
  onCurrentTeamChange?: (teamId: string) => void;
}

const DraftPrepHeader: React.FC<DraftPrepHeaderProps> = ({
  title,
  description,
  season,
  dynastyWeight,
  onSeasonChange,
  onDynastyWeightChange,
  teams = [],
  currentTeamId,
  onCurrentTeamChange,
}) => {
  const location = useLocation();
  const dynastyPercent = Math.round(dynastyWeight * 100);

  return (
    <>
      <header className="draft-prep-hero">
        <div>
          <span className="draft-prep-eyebrow">League draft room · 10 teams · 2QB · 5 keepers</span>
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        <div className="draft-prep-controls">
          <label>
            <span>Draft season</span>
            <input
              type="number"
              min="2002"
              max="2200"
              value={season}
              onChange={(event) => onSeasonChange(Number(event.target.value))}
            />
          </label>
          <label className="draft-prep-weight">
            <span>Dynasty influence <strong>{dynastyPercent}%</strong></span>
            <input
              type="range"
              min="0"
              max="50"
              step="5"
              value={dynastyPercent}
              onChange={(event) => onDynastyWeightChange(Number(event.target.value) / 100)}
            />
            <small>{100 - dynastyPercent}% current year · {dynastyPercent}% keeper horizon</small>
          </label>
          {teams.length > 0 && onCurrentTeamChange && (
            <label className="draft-prep-team-select">
              <span>Current team</span>
              <select
                aria-label="Current team"
                value={currentTeamId}
                onChange={(event) => onCurrentTeamChange(event.target.value)}
              >
                {teams.map((team) => (
                  <option key={team.teamId} value={team.teamId}>{team.teamName}</option>
                ))}
              </select>
              <small>Your projected keepers are green</small>
            </label>
          )}
        </div>
      </header>
      <nav className="draft-prep-tabs" aria-label="Draft preparation views">
        <Link
          to="/draft-prep/rankings"
          className={location.pathname.endsWith('/rankings') ? 'active' : ''}
        >
          Master rankings
        </Link>
        <Link
          to="/draft-prep/keepers"
          className={location.pathname.endsWith('/keepers') ? 'active' : ''}
        >
          Keeper options
        </Link>
      </nav>
    </>
  );
};

export default DraftPrepHeader;
